if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form.form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.outOfStockForm;

      this.outOfStockFormTop = this.querySelector('form.out-of-stock-product-form-top');
      if (this.outOfStockFormTop) {
        this.outOfStockFormTop.addEventListener('submit', this.onOutOfStockSubmitHandler.bind(this));
      }

      this.outOfStockFormBottom = this.querySelector('form.out-of-stock-product-form-bottom');
      if (this.outOfStockFormBottom) {
        this.outOfStockFormBottom.addEventListener('submit', this.onOutOfStockSubmitHandler.bind(this));
      }

      // Dynamically compute body padding-bottom to prevent fixed positioning element overlap with footer
      this.adjustBodyPaddingForFloatingElement();
      window.addEventListener('resize', () => this.adjustBodyPaddingForFloatingElement());
    }

    adjustBodyPaddingForFloatingElement() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (!isMobile) {
        document.body.style.paddingBottom = '0';
        return;
      }

      const floatingElement = document.querySelector('.product__info-container-sticky .product-form');
      if (floatingElement && floatingElement.offsetHeight > 0) {
        const elementHeight = floatingElement.offsetHeight;
        document.body.style.paddingBottom = (elementHeight) + 'px';
      } else {
        document.body.style.paddingBottom = '0';
      }
    }

    onOutOfStockSubmitHandler(evt) {
      evt.preventDefault();
      this.outOfStockForm = evt.currentTarget;
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleOutOfStockErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.out-of-stock-loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      
      config.headers['accept-encoding'] = 'gzip, deflate, br';
      config.headers['method'] = 'GET';
      config.headers['Access-Control-Allow-Origin'] = '*';
      config.headers['Accept'] = 'application/json';
      config.mode = 'no-cors';

      console.log(config);

      const formData = new FormData(this.outOfStockForm);
      config['method'] = 'GET';

      const queryString = new URLSearchParams(formData).toString();

      fetch(this.outOfStockForm.dataset.action + '?' + queryString, config)
        .then((response) => {
          console.log('Success:', response);
          return response.json();
        })
        .then((data) => {
          console.log('Success:', data);
          if (data.status) {
            this.handleOutOfStockErrorMessage(data.description);
            return;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          alert('Thank you! We will notify you when the item will be back in stock.');
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.out-of-stock-loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleOutOfStockErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.out-of-stock__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.out-of-stock__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('.product-form__submit[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;
      var skip_atc = false;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      this.querySelectorAll('fieldset').forEach((fieldset) => {
        if (fieldset.outerText.includes('SELECT')) {
          alert("Please select a product size.")

          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          skip_atc = true
        }
      });

      if (!skip_atc) {

        skip_atc = false

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
  
          // this.cartNotification.renderContents(response);
          // document.querySelector('cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
          // document.getElementById('main-cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0); document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
          window.mini_cart.updateCart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (!customElements.get('buy-now-button')) {
  customElements.define(
    'buy-now-button',
    class BuyNowButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();

        // Encuentra el formulario más cercano
        const form = this.closest("form");
        if (!form) {
          console.warn("Product form was not found.");
          return;
        }

        // Obtiene variant ID y cantidad
        const formData = new FormData(form);
        const variantId = formData.get("id");
        const quantity = formData.get("quantity") || 1;

        if (!variantId) {
          alert("Please choose a product variant.");
          return;
        }

        // Redirige usando cart permalink
        const permalink = `/cart/${variantId}:${quantity}`;
        window.location.href = permalink;
      }
    }
  );
}